var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../../network';
import { useSession } from '../../../../infra/session';
import { getCampaignOwnerOrViewerIdAndKind } from '../utils/get-campaign-owner-or-viewer-id-and-kind';
import { useRouteParams } from '../../../../infra/routing';
import { useCampaignDetails } from './use-campaign-details';
export var useAvailableAudiences = function (props) {
    var session = useSession().data;
    var campaignId = useRouteParams().campaignId;
    var campaign = useCampaignDetails(campaignId).campaign;
    var ownerOrViewerIdAndKind = getCampaignOwnerOrViewerIdAndKind(campaign, session);
    var newCustomerWeeks = props.newCustomerWeeks, _a = props.sms, sms = _a === void 0 ? true : _a, _b = props.push, push = _b === void 0 ? true : _b, _c = props.email, email = _c === void 0 ? true : _c;
    var _d = useApiQuery({
        endpoint: endpoints.audienceSegmentsQuery,
        payload: __assign({ ownerType: ownerOrViewerIdAndKind === null || ownerOrViewerIdAndKind === void 0 ? void 0 : ownerOrViewerIdAndKind.kind, ownerId: ownerOrViewerIdAndKind === null || ownerOrViewerIdAndKind === void 0 ? void 0 : ownerOrViewerIdAndKind.id, sms: sms, push: push, email: email }, (newCustomerWeeks ? { newCustomerWeeks: newCustomerWeeks } : {})),
        options: {
            enabled: !!ownerOrViewerIdAndKind,
            keepPreviousData: true,
        },
    }), data = _d.data, isLoading = _d.isLoading;
    return {
        availableAudiences: data,
        isLoading: isLoading,
    };
};
